import { Button } from "@gravity-ui/uikit";
import cn from "classnames";

import css from "./ProductPriceDetailsButton.module.scss";

interface ProductPriceDetailsButtonProps {
  value: string;
  isBlur: boolean;
  isUnavailable?: boolean;
  selected: Record<string, string>;
  attributeName: string;
  onChange: (next: Record<string, string>) => void;
}

export const ProductPriceDetailsButton = ({
  value,
  isBlur,
  isUnavailable,
  attributeName,
  selected,
  onChange,
}: ProductPriceDetailsButtonProps) => {
  const isActive = selected[attributeName] === value;

  return (
    <Button
      disabled={isBlur || isUnavailable}
      key={value}
      size="m"
      pin="round-round"
      view={isActive ? "action" : "outlined"}
      className={cn({ [css.blur]: isBlur })}
      onClick={() =>
        onChange({
          ...selected,
          [attributeName]: value,
        })
      }
    >
      {value}
    </Button>
  );
};
